import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../common_components/common_widgets/data-grid";
import MdaeButton from "../../common_components/common_widgets/button";
import MdaeCheckBox from "../../common_components/common_widgets/check-box";
import { getDataGridActionEllipsisComponent } from "../../common_components/common_widgets/data-grid-action-ellipsis";
import MdaeActionPopover from "../../common_components/common_widgets/menu-action-popover";
import { callOperation } from "async-ops";
import {
  TOGGLE_DOCUMENT_DATA_GRID_ACTION_POPOVER,
  SET_HEADER_RANGE_FILTER_COUNT,
  TOGGLE_DOCUMENT_SELECT_ALL_FLAG,
  SET_INCLUDE_NON_AUDIT_LEVEL_DOCUMENTS,
  REFRESH_USER_DOCUMENT_GRID,
  SET_IS_STOP_DOCUMENT_POLLING,
  TOGGLE_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP,
  SET_ZIP_FILE_DOWNLOAD_NAME,
  SET_DOCUMENT_STORE_DATASOURCE,
  setDocumentManagementGridInstance,
  SET_DOCUMENT_DATA_TO_SAVE,
} from "./reducers/document-management-reducer";
import {
  SHOW_LOADER,
  HIDE_LOADER,
  TOGGLE_NOTIFY_POPUP,
} from "../../common_components/mdae-common-reducer";
import { GET_DOCUMENTS } from "./services/get-documents";
import { DELETE_DOCUMENT } from "./services/delete-document";
import * as documentUploadFramework from "../../utils/document-upload-framework";
import { INSERT_DOCUMENT_DOWNLOAD_EVENT } from "./services/insert-document-download-event";
import { INSERT_BULK_DOCUMENT_DOWNLOAD_EVENT } from "./services/insert-bulk-document-download-event";
import { logDocumentLifecycleEvent } from "./services/log-document-lifecycle-event";
import { SAVE_DOCUMENT_EDIT_HISTORY } from "./services/save-document-edit-history";
import EditDocumentPopup, { DOCUMENT_POPUP_MODE, toggleEditDocumentPopupVisible } from "./edit-document-popup";
import DataGridRecordsFilter from "../common_widgets/data-grid-records-filter/component";
import { documentsGridSelection as defaultDocumentsGridSelection } from "./reducers/document-management-reducer";
import "./index.scss";
import { TOGGLE_CONFIRMATION_POPUP } from "../mdae-common-reducer";
import { first, isEqual } from "lodash";
import { GET_USER_DOCUMENT_CATEGORY_LIST } from "./services/get-document-category-list";
import { bindActionCreators } from "redux";
import { actions as asyncActions } from "async-ops";
import ArrayStore from "devextreme/data/array_store";
import { NOTIFY_POPUP_TYPES } from "../common_widgets/notify-popup";
import $ from "jquery";
import ZipFileDonwloaConfirmPopup from "./zip-file-download-confirmation";
import { esmdRoundSubmittedCellRender } from "../case-details/esMd-dashboard/esmd-round-submitted-cell-render";
import { UPDATE_CASE_DETAIL_LIST_DATA } from "../../pages/external-audit/case-list/reducers/case-list-reducer";
import {
  FG_DOCUMENT_MANAGEMENT,
  FG_EXTERNAL_USER_TASK_EDITING,
  hasAnyFeatureGroupAccess,
} from "../user-permissions-helper";
import { CREATE_ESMD_DOCUMENT_DRAFT } from "./services/save-esmd-document";
import { LOCK_DOCUMENT, LockDocumentResponse } from "./services/lock-document";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../common_widgets/toast/notify";
import { SET_CASE_DETAIL_DATA } from "../../pages/external-audit/case-detail/reducers/case-detail-reducer";
import { GET_DRAFT_DOCUMENT } from "../case-details/esMd-dashboard/services/get-draft-document";
import CheckBox, { InitializedEvent, ValueChangedEvent } from "devextreme/ui/check_box";
import { checkListIsEqual } from "../mdae-framework";
import { SET_ESMD_SELECTED_TAB_INDEX } from "../case-details/esMd-dashboard/reducers/esmd-submission-reducer";
import dxDataGrid, { SelectionChangedEvent } from "devextreme/ui/data_grid";
import dxCheckBox from "devextreme/ui/check_box";
import { UPDATE_PREFERENCE } from "../../pages/external-dashboard/services/update-preference";
import { GET_PREFERENCE } from "../../pages/external-dashboard/services/get-preference";
import { EditorPreparingEventEx } from "./types";
import Guid from "devextreme/core/guid";
import MdaeRadioGroup from "../common_widgets/radio-group";
import CircularProgressWithLabel from "../common_widgets/cIrcular-progress-indicator";
interface IDocumentManagementProps {
  hasAuditViewAccess: boolean;
  attachedLevelName?: string;
  attachedLevelId?: any;
  showForCoderReviewInd?: boolean;
  isManagerView?: boolean;
  isBulkDwonloadVisible?: boolean;
  isIncludeNonAuditLevelDocumentCheckBoxVisible?: boolean;
  doNotLoadDatasourcesInd?: boolean;
  doNotLoadEditDocumentPopup?: boolean;
  isFromCaseDetails?: boolean;
  isDocumentUploadDisable?: boolean;
  taskAttachmentLevel?: string ;
  parentAttachmentLevelName?: string;
  parentAttachmentLevelId?: string;
  showDocumentLibrary?: boolean;
  userActionMode?: string;
  height?: string;
  setSelectedRowData?: (selectedRowKeys: any[]) => void;
  selectedRowsData?: any[];
  isViewOnlyGrid?: boolean;
}
const deleteMessage =
  "Deleting a document cannot be undone. Do you want to continue?";
const bulkdeleteMessage =
  "The action cannot be undone. Do you want to continue?";
const deleteDraftDocumentMessage =
  "You are about to delete a document that is also part of a submission. This will delete the document from all locations - Are you sure you want to delete this document?";
export const USER_ACTION_MODE = Object.freeze({
  MULTIPLE_DOWNLOAD: "MULTIPLE_DOWNLOAD",
  DELETE: "DELETE",
  MULTIPLE_ESMD_SELECTION: "MULTIPLE_ESMD_SELECTION",
  MULTIPLE_SELECTION: "MULTIPLE_SELECTION",
  SMART_SCAN_SINGLE_SELECTION: "SMART_SCAN_SINGLE_SELECTION",
  VALIDATE_SINGLE_SELECTION:"VALIDATE_SINGLE_SELECTION"
});

const FILE_TYPE_PDF = "pdf";
const EDITOR_PATH_PDF = "/utils/pdfeditor";
const EDITOR_PATH_WORD = "/utils/wordeditor";

const FILE_TYPES = [FILE_TYPE_PDF];
// Formats the DevExpress RichEdit editor can round-trip natively.
const EDITABLE_FILE_TYPES = [
  "docx", "doc", "docm", "dot", "dotm", "dotx",
  "rtf",
  "txt",
  FILE_TYPE_PDF,
];
const isEditableFileType = (fileType?: string): boolean =>
  !!fileType && EDITABLE_FILE_TYPES.includes(fileType.toLowerCase());
const getEditorPath = (fileType?: string): string =>
  fileType?.toLowerCase() === FILE_TYPE_PDF ? EDITOR_PATH_PDF : EDITOR_PATH_WORD;
const ESMD_FILE_SIZE = {
  FILE_SIZE: 500 * 1024 * 1024,
};
function isFileSelectableForESMDOrSmartScan(e: any) {
  return  e?.fileSize > 0 &&
  (isValidateFileSizeForEsmdOrSmartScan(e?.fileSize) &&
    (e?.fileType &&
      FILE_TYPES.includes(e?.fileType?.toLowerCase())) &&
    !e?.isDocInEsmdDraft);
}
function isSelectAll(dataGrid: dxDataGrid<any, number>){
  let items: any[] = [];
  dataGrid.getDataSource().store().load().then((data) => {
    items = data as any[];
  });
  let selectableItems = items.filter(isFileSelectableForESMDOrSmartScan);
  let selectedRowKeys = dataGrid.option("selectedRowKeys");
  if (!selectedRowKeys || !selectedRowKeys.length) {
    return false;
  }
  return selectedRowKeys.length >= selectableItems.length ? true : undefined;
}
export const isValidateFileSizeForEsmdOrSmartScan = (fileSizeinBytes) => {
  return fileSizeinBytes <= ESMD_FILE_SIZE.FILE_SIZE;
};
export const getReleventFileSizeUnitFromBytes = (fileSizeInBytes) => {
  const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
  const fileSizeInKB = fileSizeInBytes / 1024;
  let fileSizeString = "";
  if (fileSizeInMB >= 1) {
    fileSizeString = fileSizeInMB.toFixed(2) + " MB";
  } else {
    if (fileSizeInKB >= 1) {
      fileSizeString = fileSizeInKB.toFixed(2) + " KB";
    } else {
      fileSizeString = fileSizeInBytes + " B";
    }
  }
  return fileSizeString;
};
export const readExcelFromBucket = (dispatch, s3ObjectName, documentName, originalFileName, setExcelRows) => {
  dispatch({ type: SHOW_LOADER });

  documentUploadFramework
    .NewInstance()
    .readExcelFromBucket(
      s3ObjectName,
      documentName + "." + originalFileName.split(".").pop()
    )
    .then((rows) => {
      setExcelRows(rows);
    })
    .finally(() => {
      dispatch({ type: HIDE_LOADER });
    });
};


export const downloadDocumentFromS3 = (
  dispatch,
  asyncAction,
  s3ObjectName,
  documentName,
  originalFileName,
  documentId,
  attachedLevelId,
  attachedLevelName,
  skipDownloadEvent = false
) => {
  dispatch({ type: SHOW_LOADER });
  const promise = documentUploadFramework.NewInstance().downloadDocumentFromBucket(
    s3ObjectName,
    documentName + "." + originalFileName.split(".").pop()
  );
  promise.then(() => {
    dispatch({ type: HIDE_LOADER });
    if (!skipDownloadEvent) {
      asyncAction.asyncOperationStart(INSERT_DOCUMENT_DOWNLOAD_EVENT, {
        documentId: documentId,
        attachedLevelId: attachedLevelId,
        attachedLevelName
      });
      callOperation(SAVE_DOCUMENT_EDIT_HISTORY, {
        documentId,
        changes: [{ changeType: "DOCUMENT_DOWNLOADED", deltaJson: "{}" }],
      }).catch(() => {});
    }
  });
};
export const DOCUMENT_EVENT_TYPES = {
  UPLOADED_DOCUMENT: "UPLOADED_DOCUMENT",
  NON_UPLOADED_DOCUMENT: "NON_UPLOADED_DOCUMENT",
}
export const previewDocumentFromS3 = (
  dispatch,
  asyncAction,
  s3ObjectName,
  documentName,
  originalFileName,
  documentId,
  attachedLevelId,
  attachedLevelName,
  documentDownloadEventType: typeof DOCUMENT_EVENT_TYPES[keyof typeof DOCUMENT_EVENT_TYPES] = DOCUMENT_EVENT_TYPES.UPLOADED_DOCUMENT
) => {
  return new Promise<void>((resolve, reject) => {
    dispatch({ type: SHOW_LOADER });
    const fileName = documentName + "." + originalFileName.split(".").pop();
    const promise = documentUploadFramework
      .NewInstance()
      .previewDocumentFromBucket(s3ObjectName, fileName);
    promise.then(() => {
      dispatch({ type: HIDE_LOADER });
      if (
        documentDownloadEventType ===
        DOCUMENT_EVENT_TYPES.UPLOADED_DOCUMENT
      ) {
        callOperation(
          INSERT_DOCUMENT_DOWNLOAD_EVENT,
          {
            documentId: documentId,
            attachedLevelId: attachedLevelId,
            attachedLevelName,
          },
        ).catch((res) => {
          reject(res);
          mdaeNotify({
            message: "Unable to insert document event.",
            messageType: NOTIFY_MESSAGE_TYPE.ERROR,
          });
        });
        callOperation(SAVE_DOCUMENT_EDIT_HISTORY, {
          documentId,
          changes: [{ changeType: "DOCUMENT_DOWNLOADED", deltaJson: "{}" }],
        }).catch(() => {});
      }
      resolve();
    });
  });
};
let poolingIntervalId = null;
let currentPoolInterval = 10;
const maxPoolInterval = 60;
const setUpPoolingForUnscannedFiles = function (
  isClosePooling = false,
  dispatch
) {
  if (isClosePooling) {
    if (poolingIntervalId) {
      clearInterval(poolingIntervalId);
      poolingIntervalId = null;
    }
  } else {
    currentPoolInterval = 10;
    startPoolingUnscannedFiles(dispatch);
  }
};
const startPoolingUnscannedFiles = function (dispatch) {
  poolingIntervalId = setInterval(function () {
    if (currentPoolInterval < maxPoolInterval) {
      currentPoolInterval += currentPoolInterval;
      setUpPoolingForUnscannedFiles(true, dispatch);
      startPoolingUnscannedFiles(dispatch);
    }
    dispatch({ type: REFRESH_USER_DOCUMENT_GRID });
  }, currentPoolInterval * 1000);
};
const StopDocumentPooling: React.FC<any> = () => {
  const isStopDocumentPooling = useSelector(
    (state) => state["documentManagementReducer"].isStopDocumentPooling,
    isEqual
  );
  const dispatch = useDispatch();
  if (isStopDocumentPooling) {
    setUpPoolingForUnscannedFiles(true, dispatch);
    dispatch({
      type: SET_IS_STOP_DOCUMENT_POLLING,
      isStopDocumentPooling: false,
    });
  }
  return <></>;
};
const DocumentManagement: React.FC<IDocumentManagementProps> = (props) => {
  const dispatch = useDispatch();
  const [documentDataGridInstance, setDocumentDataGridInstance] = useState<dxDataGrid>(
    null
  );
  const [documentsGridSelection, setDocumentSelection] = useState({...defaultDocumentsGridSelection});
  const getCurrentSelectedRowData: any = () => {
    return first(documentDataGridInstance?.getSelectedRowsData());
  };
  const documentsGridSelectionMode = documentsGridSelection.mode;
  const totaleDocumentCount: any = useSelector(
    (state) => state["documentManagementReducer"].totalDocumentCount,
    isEqual
  );
  const refreshDocumentGrid = useSelector(
    (state) => state["documentManagementReducer"].refreshDocumentGrid,
    isEqual
  );
  const monthRange = useSelector(
    (state) => state["documentManagementReducer"].headerRangeFilterCount,
    isEqual
  );
  const totalDatAllowance: any = useSelector(
    (state) => state["documentManagementReducer"].totalDatAllowance,
    isEqual
  );
  const totalDocumentSpaceAvailable = useSelector(
    (state) => state["documentManagementReducer"].totalDocumentSpaceAvailable,
    isEqual
  );
  const notVisiblDocumentCount = useSelector(
    (state) => state["documentManagementReducer"].notVisiblDocumentCount,
    isEqual
  );
  const notVisibleUtilizedFileSize = useSelector(
    (state) => state["documentManagementReducer"].notVisibleUtilizedFileSize,
    isEqual
  );
  const selectedDocumentId = useSelector(
    (state) => state["documentManagementReducer"].selectedDocumentId,
    isEqual
  );
  const [currentUserActionMode, setCurrentUserActionMode] = useState(props.userActionMode);
  const isDocumentSelectAllCheckBoxClicked = useSelector(
    (state) =>
      state["documentManagementReducer"].isDocumentSelectAllCheckBoxClicked,
    isEqual
  );
  const includeNonAuditLevelDocumentInd = useSelector(
    (state) =>
      state["documentManagementReducer"].includeNonAuditLevelDocumentInd,
    isEqual
  );
  const isDocumentUploadDisabled = useSelector(
    (state) => state["documentManagementReducer"].isDocumentUploadDisabled,
    isEqual
  );
  const zipFileDownloadName = useSelector(
    (state) => state["documentManagementReducer"].zipFileDownloadName,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const [dataSourceStoreId, _] = useState(new Guid().toString());
  const documentList = useSelector(
    (state) => state["documentManagementReducer"].documentStore[dataSourceStoreId]
  );

  const hasDocMngmntOrExtrnlUserTaskEditFg = useMemo(
    () =>
      hasAnyFeatureGroupAccess(
        [FG_DOCUMENT_MANAGEMENT, FG_EXTERNAL_USER_TASK_EDITING],
        currentUser
      ),
    [currentUser]
  );
  const currentEaAuditRound = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds[0],
    isEqual
  );
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData,
    isEqual
  );
  const isCurrentRequesterReviewContractorValid = useSelector(
    (state) =>
      state["externalAuditReducer"].isCurrentRequesterReviewContractorValid,
    isEqual
  );
  const isCurrentContentTypeInvalidForReviewContractor = useSelector(
    (state) =>
      state["externalAuditReducer"]
        .isCurrentContentTypeInvalidForReviewContractor,
    isEqual
  );
  const draftDocumentList = useSelector(
    (state) => state["esmdSubmissionReducer"].draftDocumentList,
    checkListIsEqual
  );
  const caseDataTabData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );

  const isEhrInboundAPIEnabled = useSelector(
    (state) => state["documentManagementReducer"].isEhrInboundAPIEnabled
  );

  let uploadedDraftDocumentTotalSize: any = 0.0;
  draftDocumentList?.map((item) => {
    uploadedDraftDocumentTotalSize += item.fileSize;
  });

  const datagridSelectionRef = useRef<{
    checkBoxUpdating: boolean,
    selectAllCheckBox: dxCheckBox | null
  }>({
    checkBoxUpdating: false,
    selectAllCheckBox: null
  });

  const onEditorPreparing = useCallback((e: EditorPreparingEventEx<any, number>) => {
    if (
      currentUserActionMode !==
      USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION &&
      currentUserActionMode !==
      USER_ACTION_MODE.SMART_SCAN_SINGLE_SELECTION
    ) return;
    let dataGrid = e.component;
    if (e.type !== 'selection') return;
    if (e.parentType === 'dataRow' && e.row && !isFileSelectableForESMDOrSmartScan(e.row.data))
      e.editorOptions.disabled = true;
    if (e.parentType === "headerRow" && currentUserActionMode ===
      USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION) {
      e.editorOptions.onInitialized = (e: InitializedEvent) => {
        if (e.component)
          datagridSelectionRef.current.selectAllCheckBox = e.component;
      };
      e.editorOptions.value = isSelectAll(dataGrid);
      e.editorOptions.onValueChanged = (e: ValueChangedEvent) => {
        if (!e.event) {
          if (e.previousValue && datagridSelectionRef.current.checkBoxUpdating)
            e.component.option("value", e.previousValue);
          return;
        }
        if (isSelectAll(dataGrid) === e.value)
          return;
        e.value ? dataGrid.selectAll() : dataGrid.deselectAll();
        e.event.preventDefault();
      }
    }

  }, [currentUserActionMode])

  const getSelectedDocumentFileSize = () => {
    let selectedRowsData: any[] = documentDataGridInstance?.getSelectedRowsData();
    let totalSelectedFileSize = 0;
    selectedRowsData = selectedRowsData ? selectedRowsData : [];
    selectedRowsData?.map((item) => {
      totalSelectedFileSize += item.fileSize;
    });
    return totalSelectedFileSize;
  };

  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );

  const toFixedNoRounding = function (number, n) {
    const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g");
    const a = number.toString().match(reg)[0];
    const dot = a.indexOf(".");
    if (dot === -1) {
      // integer, insert decimal dot and pad up zeros
      return a + "." + "0".repeat(n);
    }
    const b = n - (a.length - dot) + 1;
    return b > 0 ? a + "0".repeat(b) : a;
  };
  const onDocumentsDataGridInitialized = (e) => {
    setDocumentDataGridInstance(e.component);
  };
  useEffect(() => {
    if (refreshDocumentGrid) {
      if (props.attachedLevelId && props.attachedLevelName) {
        asyncAction.asyncOperationStart(GET_DOCUMENTS, {
          attachedLevelId: props.attachedLevelId,
          attachedLevelName: props.attachedLevelName,
          showForCoderReviewInd: includeNonAuditLevelDocumentInd,
          isManagerView: props.isManagerView,
          uniqueId: dataSourceStoreId,
        });
      } else {
        asyncAction.asyncOperationStart(GET_DOCUMENTS, {
          monthRange: monthRange,
          isManagerView: props.isManagerView,
          uniqueId: dataSourceStoreId,
        });
      }
    }
  }, [refreshDocumentGrid]);

  useEffect(() => {
    if (documentDataGridInstance) {
      setDocumentManagementGridInstance(documentDataGridInstance);
    }
  }, [documentDataGridInstance]);

  useEffect(() => {
    if (props.attachedLevelId && props.attachedLevelName) {
      callOperation(GET_PREFERENCE, {
        name:
          props.attachedLevelName == "EA"
            ? "EA_Include_Non_Audit_Level_Documents"
            : "EAC_Include_Non_Case_Level_Documents",
      }).then((response) => {
        let settings = JSON.parse(response?.settings);
        let includeNonAuditLevelDocumentInd = settings == null ? 0 : settings;
        dispatch({
          type: SET_INCLUDE_NON_AUDIT_LEVEL_DOCUMENTS,
          data: {
            includeNonAuditLevelDocumentInd: includeNonAuditLevelDocumentInd,
          },
        });
        if (props.attachedLevelName?.toLowerCase() === "eac") {
          asyncAction.asyncOperationStart(GET_DRAFT_DOCUMENT, {
            eaCaseId: props.attachedLevelId,
          });
        }
        asyncAction.asyncOperationStart(GET_DOCUMENTS, {
          attachedLevelId: props.attachedLevelId,
          attachedLevelName: props.attachedLevelName,
          showForCoderReviewInd: includeNonAuditLevelDocumentInd,
          isManagerView: props.isManagerView,
          uniqueId: dataSourceStoreId,
        });
      });
    } else if (props.isManagerView) {
      asyncAction.asyncOperationStart(GET_DOCUMENTS, {
        monthRange: 6,
        isManagerView: props.isManagerView,
        uniqueId: dataSourceStoreId,
      });
    }
    if (!props.doNotLoadDatasourcesInd) {
      asyncAction.asyncOperationStart(GET_USER_DOCUMENT_CATEGORY_LIST);
    }
  }, [props.attachedLevelId, props.attachedLevelName]);

  useEffect(() => {
    return () => {
      dispatch({
        type: SET_DOCUMENT_STORE_DATASOURCE,
        data: {
          documentStore: {
            [dataSourceStoreId]: [],
          },
        },
      });
    };
  }, []);

  const toggleDocumentGridCheckboxes = (_currentUserActionMode = "") => {
    if (documentsGridSelectionMode === "multiple") {
      documentDataGridInstance.columnOption("documentId", "visible", true);
      setDocumentSelection({
        ...defaultDocumentsGridSelection,
        mode: "single",
      });
      setCurrentUserActionMode("")
      dispatch({
        type: TOGGLE_DOCUMENT_SELECT_ALL_FLAG,
        isDocumentSelectAllCheckBoxClicked: false,
      });
      setDocumentSelection({
        ...documentsGridSelection,
        allowSelectAll: true,
      });
      documentDataGridInstance.clearSelection();
    } else {
      documentDataGridInstance.columnOption("documentId", "visible", false);
      if (
        _currentUserActionMode?.toUpperCase() ==
        USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION ) {
        documentDataGridInstance.deselectAll();
        setDocumentSelection({
          ...defaultDocumentsGridSelection,
          allowSelectAll: true,
        });
      }
      setDocumentSelection({
        ...defaultDocumentsGridSelection,
        mode: "multiple",
      });
      setCurrentUserActionMode(_currentUserActionMode);
    }
  };

  useEffect(() => {
    if(documentDataGridInstance && props.isViewOnlyGrid && documentsGridSelectionMode != "multiple")
      toggleDocumentGridCheckboxes(props.userActionMode)
  }, [documentDataGridInstance, documentList, props.userActionMode])

  const toggleTitleOfSelectAllCheckBox = (component, isTitleVisible) => {
    setTimeout(() => {
      if (isTitleVisible) {
        $(component.element())
          .find(".dx-header-row .dx-checkbox")
          .attr("title", "Click the Clear Selection button to unselect all");
      } else {
        $(component.element())
          .find(".dx-header-row .dx-checkbox")
          .attr("title", "");
      }
    });
  };
  const hideConfirmationPopup = () => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
      },
    });
  };
  const showConfirmationPopup = (message) => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: deleteSelectedDocument,
        visible: true,
        confirmShown: true,
        declineShown: true,
        width: 380,
        height: 200,
        contentHtml: message,
        onDecline: hideConfirmationPopup,
      },
    });
  };
  const toggleConfirmationPopupVisible = (isVisible, message) => {
    if (isVisible) {
      showConfirmationPopup(message);
    } else {
      hideConfirmationPopup();
    }
  };
  const toggleActionPopover = useCallback((isVisible, target) => {
    const currentSelectedRowData = getCurrentSelectedRowData();
    if (currentSelectedRowData?.maliciousFileInd !== true) {
      dispatch({
        type: TOGGLE_DOCUMENT_DATA_GRID_ACTION_POPOVER,
        data: {
          documentListDataGridActionPopoverTarget: target,
          isDocumentListDataGridActionPopoverVisible: isVisible,
        },
      });
    }
  }, [getCurrentSelectedRowData]);


  const getDocumentDeletetData = (selectedRowsData) => {
    return selectedRowsData.map((item) => ({
      attachedLevelName: item.attachedLevelName,
      attachedLevelId: item.attachedLevelId,
      documentId: item.documentId,
      s3ObjectName: item.s3ObjectName,
      documentName: item.documentName,
      isDocInEsmdDraft: item.isDocInEsmdDraft,
      isDocInEsmdSubmission: item.isDocInEsmdSubmission,
    }));
  };

  const getDocumentEventFromDocumentobject = (documentList) => {
    let documentEventList = [];
    documentList.forEach((item) => {
      documentEventList.push({
        attachedLevelId: item.attachedLevelId,
        attachedLevelName: item.attachedLevelName,
        documentId: item.documentId,
        eventName: "Download",
      });
    });
    return documentEventList;
  };
  const deleteSelectedDocument = () => {
    const selectedRowsData = documentDataGridInstance.getSelectedRowsData();
    const rowsToDelete = (selectedRowsData && selectedRowsData.length > 0)
      ? selectedRowsData
      : [getCurrentSelectedRowData()];
    const deleteData = getDocumentDeletetData(rowsToDelete);
    asyncAction.asyncOperationStart(DELETE_DOCUMENT, deleteData);
    deleteData.forEach((item) => {
      logDocumentLifecycleEvent(item.documentId, "DOCUMENT_DELETED", "delete", item.attachedLevelName, item.attachedLevelId);
    });
    toggleConfirmationPopupVisible(false, "");
    toggleActionPopover(false, null);
  };

  const actionPopoverMenuList = () => [
    {
      text: "Download",
      visible: !getCurrentSelectedRowData()?.maliciousFileInd,
      icon: () => {
        return (
          <div
            style={{ height: "16px" }}
            className={"download-icon mdae-datagrid-action-menu-item-icon"}
          ></div>
        );
      },
      onClick: (e) => {
        const currentSelectedRowData = getCurrentSelectedRowData();
        downloadDocumentFromS3(
          dispatch,
          asyncAction,
          currentSelectedRowData.s3ObjectName,
          currentSelectedRowData.documentName,
          currentSelectedRowData.originalFileName,
          currentSelectedRowData.documentId,
          currentSelectedRowData.attachedLevelId,
          currentSelectedRowData.attachedLevelName
        );
        toggleActionPopover(false, null);
      },
    },
    {
      text: "Preview",
      visible: !getCurrentSelectedRowData()?.maliciousFileInd,
      icon: () => {
        return (
          <div
            style={{ height: "14px" }}
            className={"preview-action-icon"}
          ></div>
        );
      },
      disabled: () => {
        let isDocumentPreviewable = true;
        const currentSelectedRowData = getCurrentSelectedRowData();
        if (currentSelectedRowData && currentSelectedRowData.fileType) {
          isDocumentPreviewable = ![
            "pdf",
            "jpeg",
            "jpg",
            "png",
            "txt",
            "xml",
            "html",
            "htm",
            "rtf",
          ].includes(currentSelectedRowData.fileType?.toLowerCase());
        }
        return isDocumentPreviewable;
      },
      onClick: (e) => {
        const currentSelectedRowData = getCurrentSelectedRowData();
        previewDocumentFromS3(
          dispatch,
          asyncAction,
          currentSelectedRowData.s3ObjectName,
          currentSelectedRowData.documentName,
          currentSelectedRowData.originalFileName,
          currentSelectedRowData.documentId,
          currentSelectedRowData.attachedLevelId,
          currentSelectedRowData.attachedLevelName
        );
        toggleActionPopover(false, null);
      },
    },
    {
      text: "Edit",
      className: "edit",
      visible:
        !getCurrentSelectedRowData()?.maliciousFileInd &&
        hasDocMngmntOrExtrnlUserTaskEditFg &&
        (!isEditableFileType(getCurrentSelectedRowData()?.fileType) ||
          !isEditorSupportedRow(getCurrentSelectedRowData())),
      icon: () => {
        return (
          <div style={{ height: "14px" }} className={"edit-action-icon"}></div>
        );
      },
      onClick: () => {
        const currentSelectedRowData = getCurrentSelectedRowData();
        toggleActionPopover(false, null);
        toggleEditDocumentPopupVisible(
          dispatch,
          true,
          dataSourceStoreId,
          "Edit - " + currentSelectedRowData.documentName,
          DOCUMENT_POPUP_MODE.EDIT,
          {
            documentId: currentSelectedRowData.documentId,
            documentName: currentSelectedRowData.documentName,
            documentCategoryId: currentSelectedRowData.documentCategoryId,
            attachedLevelName: currentSelectedRowData.attachedLevelName,
            isDocInEsmdSubmission:
              currentSelectedRowData.isDocInEsmdSubmission,
          }
        );
      },
    },
    {
      text: "Open Editor",
      className: "open-editor",
      visible:
        !getCurrentSelectedRowData()?.maliciousFileInd &&
        hasDocMngmntOrExtrnlUserTaskEditFg &&
        isEditableFileType(getCurrentSelectedRowData()?.fileType) &&
        isEditorSupportedRow(getCurrentSelectedRowData()),
      disabled: getCurrentSelectedRowData()?.isDocInEsmdSubmission,
      icon: () => {
        return (
          <div style={{ height: "14px" }} className={"edit-action-icon"}></div>
        );
      },
      onClick: async () => {
        const row = getCurrentSelectedRowData();
        toggleActionPopover(false, null);
        dispatch({ type: SHOW_LOADER });
        try {
          const lockResult: LockDocumentResponse = await callOperation(
            LOCK_DOCUMENT,
            {
              documentId: row.documentId,
              attachedLevelName: row.attachedLevelName,
              attachedLevelId: row.attachedLevelId,
            }
          );
          dispatch({ type: HIDE_LOADER });
          if (!lockResult?.isLocked) {
            // Uses the app's shared NotifyPopup (via TOGGLE_NOTIFY_POPUP).
            // SUCCESS type gives us the green icon; the title override "Document
            // Locked" makes the semantics right. Countdown-only per product
            // requirement — no user name.
            // Countdown format:
            //   >= 60s → "m:ss minutes"
            //   <  60s → "N seconds"
            // Always shows an actual number — no fallback strings.
            const msLeft = Math.max(0, lockResult?.msRemaining ?? 0);
            const totalSec = Math.round(msLeft / 1000);
            let waitText: string;
            if (totalSec >= 60) {
              const mm = Math.floor(totalSec / 60);
              const ss = totalSec % 60;
              waitText = `${mm}:${ss.toString().padStart(2, "0")} minutes`;
            } else {
              waitText = `${totalSec} seconds`;
            }
            dispatch({
              type: TOGGLE_NOTIFY_POPUP,
              data: {
                visible: true,
                width: 460,
                // Compact fixed height. Room for the title bar (~50px),
                // two lines of content (~50px), and the OK footer (~55px)
                // with a little breathing room. Tighter than the icon
                // variant since we're hiding the checkmark.
                height: 190,
                title: "Document Locked",
                contentHtml: () => (
                  <div>
                    This document is currently being edited by another user.
                    <br />
                    Try again in <strong>{waitText}</strong>.
                  </div>
                ),
                notifyPopupType: NOTIFY_POPUP_TYPES.SUCCESS,
                isHideNotifyTypeIcon: true,
                closeButtonText: "OK",
              },
            });
            return;
          }
          const editorParams = new URLSearchParams({
            documentId: String(row.documentId),
            s3ObjectName: row.s3ObjectName,
            documentName: row.documentName,
            documentCategoryName: row.documentCategoryName || "",
            // documentCategoryId lets the editor pre-select the current
            // category in its dropdown when the user opens the doc.
            documentCategoryId:
              row.documentCategoryId != null
                ? String(row.documentCategoryId)
                : "",
            attachedLevelName: row.attachedLevelName,
            attachedLevelId: String(row.attachedLevelId),
            fileType: (row.fileType || "").toLowerCase(),
            // Pass the actual server-configured idle timeout so the editor's
            // passive expiry timer matches the server (per-env appsettings).
            idleTimeoutMs: String(lockResult?.idleTimeoutMs ?? 300_000),
          });
          const editorWindow = window.open(
            `${getEditorPath(row.fileType)}?${editorParams.toString()}`,
            "_blank"
          );
          const refreshOnSave = () => {
            if (props.attachedLevelId && props.attachedLevelName) {
              asyncAction.asyncOperationStart(GET_DOCUMENTS, {
                attachedLevelId: props.attachedLevelId,
                attachedLevelName: props.attachedLevelName,
                showForCoderReviewInd: includeNonAuditLevelDocumentInd,
                isManagerView: props.isManagerView,
                uniqueId: dataSourceStoreId,
              });
            } else {
              asyncAction.asyncOperationStart(GET_DOCUMENTS, {
                monthRange: monthRange,
                isManagerView: props.isManagerView,
                uniqueId: dataSourceStoreId,
              });
            }
          };
          window.addEventListener("documentSaved", refreshOnSave, { once: true });
          if (!editorWindow) {
            window.removeEventListener("documentSaved", refreshOnSave);
            mdaeNotify({
              message: "Popup blocked. Please allow popups to edit documents.",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
          }
        } catch (e) {
          dispatch({ type: HIDE_LOADER });
          mdaeNotify({
            message: "Failed to open editor. Please try again.",
            messageType: NOTIFY_MESSAGE_TYPE.ERROR,
          });
        }
      },
    },
    {
      text: "Delete",
      visible: hasDocMngmntOrExtrnlUserTaskEditFg,
      disabled: getCurrentSelectedRowData()?.isDocInEsmdSubmission,
      icon: () => {
        return (
          <div
            style={{ height: "16px" }}
            className={"delete-action-icon"}
          ></div>
        );
      },
      onClick: () => {
        toggleConfirmationPopupVisible(
          true,
          getCurrentSelectedRowData().isDocInEsmdDraft
            ? deleteDraftDocumentMessage
            : deleteMessage
        );
        toggleActionPopover(false, null);
      },
    },
  ];
  const renderDocumentRadio = useCallback(
    (e) => {
      const isValidateSingleDOcument =
        currentUserActionMode === USER_ACTION_MODE.VALIDATE_SINGLE_SELECTION;

      if (!isValidateSingleDOcument) return null;

      const isValid = e.data.fileType === "xlsx";
      const documentId = e.data.documentId;

      const handleValueChanged = (event) => {
        if (!isValid) return;

        dispatch({
          type: SET_DOCUMENT_DATA_TO_SAVE,
          data: {
            selectedDocumentId: event.value,
          },
        });
      };

      return (
        <MdaeRadioGroup
          id={`${documentId}`}
          valueExpr="id"
          displayExpr="label"
          value={selectedDocumentId}
          items={[
            {
              id: documentId,
              label: "",
              disabled: !isValid,
            },
          ]}
          onValueChanged={handleValueChanged}
        />
      );
    },
    [currentUserActionMode, selectedDocumentId, dispatch]
  );
  const isExternalAuditRelatedDocument =
    props.attachedLevelName === "EA" || props.attachedLevelName == "EAC";
  // Returns true for levels that support the full document editor window.
  // "PA Task" / "PA Task Case" = TS rows whose parent is a payer-audit level.
  const isEditorSupportedRow = (row: any): boolean => {
    const level = row?.attachedLevelName;
    return (
      level === "EA" ||
      level === "EAC" ||
      (level === "TS" &&
        (row?.parentAttachedLevelName === "EA" ||
          row?.parentAttachedLevelName === "EAC"))
    );
  };
    const documentSelectionCellRender = useCallback(
      (e) => {
        const isValidateSingleDocument =
          currentUserActionMode === USER_ACTION_MODE.VALIDATE_SINGLE_SELECTION;

        if (isValidateSingleDocument) {
          return renderDocumentRadio(e);
        }

        return getDataGridActionEllipsisComponent(e, {
          showActionPopover: toggleActionPopover,
          entityName: "documents",
          entityId: e.data.documentId + dataSourceStoreId,
          currentRowData: e.data,
          type: "usingDispatch",
          dispatch,
        });
      },
      [
        currentUserActionMode,
        USER_ACTION_MODE,
        renderDocumentRadio,
        getDataGridActionEllipsisComponent,
        toggleActionPopover,
        dataSourceStoreId,
        dispatch,
      ]
    );
  const documentListDataGridOptions = useMemo(() => {
    return getDocumentListDataGridOptions(
      toggleActionPopover,
      dispatch,
      onDocumentsDataGridInitialized,
      props.hasAuditViewAccess,
      props.isIncludeNonAuditLevelDocumentCheckBoxVisible,
      isExternalAuditRelatedDocument,
      documentList,
      documentsGridSelection,
      dataSourceStoreId,
      props.selectedRowsData,
      documentSelectionCellRender,
      props.attachedLevelName,
      isEhrInboundAPIEnabled
    );
  }, [
    props.hasAuditViewAccess,
    props.isIncludeNonAuditLevelDocumentCheckBoxVisible,
    isExternalAuditRelatedDocument,
    documentList,
    documentsGridSelection,
    dataSourceStoreId,
    props.selectedRowsData,
    selectedDocumentId,
    renderDocumentRadio
  ]);

  const areDocumentGridCheckIfCheckboxesVisible = () => {
    return documentsGridSelectionMode === "single";
  };
  const isAnyDocumentIsRemainingForDownload = () => {
    return new Promise((resolve, reject) => {
      getDataGridVisibleRows(documentDataGridInstance).then(
        (gridDataSourceData: Array<any>) => {
          for (let i = 0; i < gridDataSourceData.length; i++) {
            if (!gridDataSourceData[i].isDocumentDownloaded) {
              resolve(true);
              return;
            }
          }
          resolve(false);
        }
      );
    });
  };

  const updateDocumentDownloadFlagInDataSource = (
    selectedRowsData,
    isDocumentDownloaded
  ) => {
    return new Promise<void>((resolve, reject) => {
      getDataGridVisibleRows(documentDataGridInstance).then(
        (gridDataSourceData: Array<any>) => {
          const assignFlag = (documentId) => {
            for (let j = 0; j < gridDataSourceData.length; j++) {
              if (documentId === -1) {
                gridDataSourceData[
                  j
                ].isDocumentDownloaded = isDocumentDownloaded;
              } else {
                if (documentId === gridDataSourceData[j].documentId) {
                  gridDataSourceData[
                    j
                  ].isDocumentDownloaded = isDocumentDownloaded;
                  break;
                }
              }
            }
          };
          if (selectedRowsData.length === 0) {
            assignFlag(-1);
          } else {
            for (let i = 0; i < selectedRowsData.length; i++) {
              assignFlag(selectedRowsData[i].documentId);
            }
          }
          resolve();
        }
      );
    });
  };
  const showMaxDataDownloadMessage = (isSelectAllMode) => {
    if (isSelectAllMode) {
      dispatch({
        type: TOGGLE_NOTIFY_POPUP,
        data: {
          height: 260,
          width: 600,
          visible: true,
          contentHtml: () => {
            return (
              <div>
                You cannot download more than 1GB at a time. The first 1GB has
                been selected for you to download. Once your download finishes,
                the next 1GB will be automatically selected for you to download.
              </div>
            );
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.WARNING,
          closeButtonText: "Close",
        },
      });
    } else {
      dispatch({
        type: TOGGLE_NOTIFY_POPUP,
        data: {
          visible: true,
          height: 220,
          width: 400,
          contentHtml: () => {
            return <div>You can download only 1 GB data at a time</div>;
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.ERROR,
          closeButtonText: "Close",
        },
      });
    }
  };

  const bulkDownloadDocumentsHandler = (selectedRowsData) => {
    documentUploadFramework.NewInstance()
      .downloadDocumentInBulk(selectedRowsData, dispatch, zipFileDownloadName)
      .then(function () {
        const documentEventList = getDocumentEventFromDocumentobject(
          selectedRowsData
        );
        asyncAction.asyncOperationStart(
          INSERT_BULK_DOCUMENT_DOWNLOAD_EVENT,
          documentEventList
        );
        selectedRowsData.forEach((item) => {
          callOperation(SAVE_DOCUMENT_EDIT_HISTORY, {
            documentId: item.documentId,
            changes: [{ changeType: "DOCUMENT_DOWNLOADED", deltaJson: "{}" }],
          }).catch(() => {});
        });
        updateDocumentDownloadFlagInDataSource(selectedRowsData, true).then(
          function () {
            setTimeout(() => {
              isAnyDocumentIsRemainingForDownload().then(
                (isAnyDocumentRemaining) => {
                  if (
                    isDocumentSelectAllCheckBoxClicked &&
                    isAnyDocumentRemaining
                  ) {
                    documentDataGridInstance.selectAll();
                  } else {
                    toggleDocumentGridCheckboxes();
                  }
                }
              );
            });
          }
        );
      });
  };
  const renderToolbarButtonTemplate = () => {
    let totalSelectedFileSize = getSelectedDocumentFileSize();
    let isTotalFileSizeValid = isValidateFileSizeForEsmdOrSmartScan(
      uploadedDraftDocumentTotalSize + totalSelectedFileSize
    );
    return (
      <div style={{ display: "flex" }}>
        {isEsmdDashboardButtonVisible &&
          currentUserActionMode?.toUpperCase() ===
            USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION && (
            <div
              className={
                "esmd-file-size-limit-label-container " +
                (isTotalFileSizeValid ? "valid" : "invalid")
              }
            >
              {getReleventFileSizeUnitFromBytes(
                uploadedDraftDocumentTotalSize + totalSelectedFileSize
              )}{" "}
              of {getReleventFileSizeUnitFromBytes(ESMD_FILE_SIZE.FILE_SIZE)}{" "}
              Limit
            </div>
          )}

        <MdaeCheckBox
          defaultValue={false}
          id="chkIncludeNonAuditLevelDocuments"
          text={
            props.attachedLevelName == "EA"
              ? "Include non-audit level documents"
              : "Include non-case level documents"
          }
          visible={Boolean(props.isIncludeNonAuditLevelDocumentCheckBoxVisible)}
          value={Boolean(includeNonAuditLevelDocumentInd)}
          onValueChanged={(e) => {
            if (e.event) {
              if (e.value)
                asyncAction.asyncOperationStart(GET_DOCUMENTS, {
                  attachedLevelId: props.attachedLevelId,
                  attachedLevelName: props.attachedLevelName,
                  showForCoderReviewInd: true,
                  isManagerView: props.isManagerView,
                  uniqueId: dataSourceStoreId,
                });
              else
                asyncAction.asyncOperationStart(GET_DOCUMENTS, {
                  attachedLevelId: props.attachedLevelId,
                  attachedLevelName: props.attachedLevelName,
                  showForCoderReviewInd: false,
                  isManagerView: props.isManagerView,
                  uniqueId: dataSourceStoreId,
                });
              dispatch({
                type: SET_INCLUDE_NON_AUDIT_LEVEL_DOCUMENTS,
                data: { includeNonAuditLevelDocumentInd: e.value },
              });
              callOperation(UPDATE_PREFERENCE, {
                name: props.attachedLevelName == "EA"
                ? "EA_Include_Non_Audit_Level_Documents"
                : "EAC_Include_Non_Case_Level_Documents",
                settings: JSON.stringify(
                  e.value ? 1 : 0
                ),
                reportType: null,
              });
            }

          }}
        />
        <MdaeButton
          id={"btnClearDocumentSelection"}
          role={"dxButton"}
          visible={Boolean(isDocumentSelectAllCheckBoxClicked)}
          stylingMode={"text"}
          className="data-grid-toolbar-button"
          elementAttr={{
            title: "Clear Selection",
          }}
          onContentReady={(e) => {
            $(e.component.element())
              .find(".dx-button-content")
              .addClass("document-clear-selection-button-content");
          }}
          onClick={() => {
            if (documentsGridSelectionMode === "multiple") {
              updateDocumentDownloadFlagInDataSource([], false);
              documentDataGridInstance.clearSelection();
              dispatch({
                type: TOGGLE_DOCUMENT_SELECT_ALL_FLAG,
                isDocumentSelectAllCheckBoxClicked: false,
              });
            }
          }}
        >
          Clear Selection
        </MdaeButton>
        <div
          title={
            props.isDocumentUploadDisable
              ? "This audit has been completed. Documents cannot be added to completed audits"
              : "Upload Document"
          }
        >
          <MdaeButton
            id={"btnUploadDocument"}
            role={"dxButton"}
            icon={
              props.isDocumentUploadDisable
                ? "dx-icon upload-grey-icon"
                : "dx-icon upload-icon"
            }
            visible={
              !props.isManagerView &&
              !isDocumentUploadDisabled &&
              hasDocMngmntOrExtrnlUserTaskEditFg &&
              !props.isViewOnlyGrid
            }
            className="data-grid-toolbar-button"
            disabled={props.isDocumentUploadDisable}
            onClick={() => {
              toggleActionPopover(false, null);
              toggleEditDocumentPopupVisible(
                dispatch,
                true,
                dataSourceStoreId,
                "Upload Document",
                DOCUMENT_POPUP_MODE.UPLOAD,
                {
                  attachedLevelId: props.attachedLevelId,
                  attachedLevelName: props.attachedLevelName,
                  documentId: 0,
                  documentName: "",
                  documentCategoryId: null,
                }
              );
            }}
          ></MdaeButton>
        </div>
        <MdaeButton
          id={"btnBulkDeleteDocument"}
          role={"dxButton"}
          icon="dx-icon delete-action-icon"
          className="data-grid-toolbar-button"
          visible={props.isManagerView && hasDocMngmntOrExtrnlUserTaskEditFg &&
            !props.isViewOnlyGrid }
          disabled={
            currentUserActionMode === USER_ACTION_MODE.MULTIPLE_DOWNLOAD
          }
          text={""}
          elementAttr={{
            title: areDocumentGridCheckIfCheckboxesVisible()
              ? "Delete Multiple Documents"
              : "Confirm Document Delete",
          }}
          onClick={() => {
            if (documentsGridSelectionMode === "multiple") {
              const selectedRowsData = documentDataGridInstance.getSelectedRowsData();
              if (selectedRowsData && selectedRowsData.length) {
                toggleConfirmationPopupVisible(true, bulkdeleteMessage);
              } else {
                toggleDocumentGridCheckboxes();
              }
            } else {
              toggleDocumentGridCheckboxes(USER_ACTION_MODE.DELETE);
            }
          }}
        ></MdaeButton>

        <MdaeButton
          id={"btnBulkDownloadDocument"}
          role={"dxButton"}
          icon="dx-icon download-icon"
          className="data-grid-toolbar-button"
          visible={ !props.isViewOnlyGrid && (props.isManagerView || props.isBulkDwonloadVisible)}
          disabled={currentUserActionMode === USER_ACTION_MODE.DELETE}
          text={""}
          elementAttr={{
            title: areDocumentGridCheckIfCheckboxesVisible()
              ? "Download Multiple Documents"
              : "Confirm Document Download",
          }}
          onClick={() => {
            if (documentsGridSelectionMode === "multiple") {
              const selectedRowsData = documentDataGridInstance.getSelectedRowsData();
              if (selectedRowsData && selectedRowsData.length) {
                if (isMaxDownloadLimitReached(selectedRowsData)) {
                  showMaxDataDownloadMessage(false);
                } else {
                  let zipFileDownloadName = "";
                  if (selectedRowsData.length > 1) {
                    zipFileDownloadName = "MDaudit Documents";
                  } else {
                    zipFileDownloadName = selectedRowsData[0].documentName;
                  }
                  dispatch({
                    type: TOGGLE_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP,
                    data: {
                      isZipDownloadConfirmPopupVisible: true,
                    },
                  });
                  dispatch({
                    type: SET_ZIP_FILE_DOWNLOAD_NAME,
                    data: {
                      zipFileDownloadName: zipFileDownloadName,
                    },
                  });
                }
              } else {
                toggleDocumentGridCheckboxes();
              }
            } else
              toggleDocumentGridCheckboxes(USER_ACTION_MODE.MULTIPLE_DOWNLOAD);
          }}
        ></MdaeButton>
      </div>
    );
  };

  const getNotifyMessage = (selectedRowsData) => {
    if (selectedRowsData.length > 1) {
      return selectedRowsData.length + " Documents Uploaded Successfully ";
    } else {
      return "1 Document Uploaded Successfully";
    }
  };

  const isEsmdDashboardButtonVisible =
    props.isFromCaseDetails &&
    caseDataTabData.rqstrRecordSubmissionMethod?.toLowerCase() == "esmd";

  const validateEsmdFileSelection = (e) => {
    if (
      currentUserActionMode != "" &&
      currentUserActionMode?.toUpperCase() ===
      USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION &&
      props.isFromCaseDetails &&
      e.rowType == "data" &&
      e.data &&
      e.data?.fileSize > 0 &&
      (!isValidateFileSizeForEsmdOrSmartScan(e.data?.fileSize) ||
        (e.data?.fileType &&
          !FILE_TYPES.includes(e.data?.fileType?.toLowerCase())) ||
        e.data?.isDocInEsmdDraft)
    ) {
      $(e.cellElement)
        .find(".dx-select-checkbox")
        .attr("style", "display: none");
      $(e.cellElement).attr("style", "pointer-events: none");
    }
  };

  return (
    <div className="document-management-content">
      <MdaeActionPopover
        mdaePopoverConfig={{
          id: "pnlDocumentsGridPopover",
          mdaeDataUpdaterConfig: [
            {
              actionType: TOGGLE_DOCUMENT_DATA_GRID_ACTION_POPOVER,
              reducerName: "documentManagementReducer",
              widgetOptionBindings: {
                target: "documentListDataGridActionPopoverTarget",
                visible: "isDocumentListDataGridActionPopoverVisible",
              },
            },
          ],
        }}
        menuItemListFunction={actionPopoverMenuList}
      ></MdaeActionPopover>
      <div className="document-list-container">
        {props.isManagerView && (
          <DataGridRecordsFilter
            id="pnlDocumentsDataGridFilter"
            infoText="Document list will display  documents for the most recent month based on the number entered in the filter."
            titleText="Refresh Document List"
            prefixText="Show The"
            suffixText="month(s) most recent document(s)"
            rangeNumber={6}
            fetchOptions={{
              reducerName: "documentManagementReducer",
              valueActionType: SET_HEADER_RANGE_FILTER_COUNT,
              fetchActionType: GET_DOCUMENTS,
              data: {
                monthRange: monthRange,
                isManagerView: props.isManagerView,
                uniqueId: dataSourceStoreId,
              },
            }}
          />
        )}
        <div className="document-list-grid-container">
          {props.isManagerView && (
            <div id="pnlVolumeInformation" className="voulume-information">
              <div className="voulume-information-count">
                <div>Total Document Count: </div>
                {totaleDocumentCount}{" "}
                <div> (Not Visible: {notVisiblDocumentCount})</div>
              </div>
              <div className="voulume-information-file-size">
                <div>Total Space Available: </div>
                {toFixedNoRounding(totalDocumentSpaceAvailable, 2)} GB out of{" "}
                {totalDatAllowance} GB{" "}
                <div> (Not Visible: {notVisibleUtilizedFileSize} MB)</div>
              </div>
            </div>
          )}
          <div className="esMdDUploadButton">
            <div>
              <MdaeButton
                id={"btnCreateDocument"}
                className={"upload-doc create-document-btn"}
                role={"primary"}
                text="Create Document"
                icon="/images/ui-rewrite-icons/auditicons/plus-white.svg"
                visible={
                  isExternalAuditRelatedDocument &&
                  !props.isManagerView &&
                  !props.isDocumentUploadDisable &&
                  hasDocMngmntOrExtrnlUserTaskEditFg &&
                  !props.isViewOnlyGrid
                }
                disabled={props.isDocumentUploadDisable}
                onClick={() => {
                  const editorParams = new URLSearchParams({
                    isNew: "true",
                    attachedLevelName: props.attachedLevelName,
                    attachedLevelId: String(props.attachedLevelId),
                    fileType: "docx",
                  });
                  const editorWindow = window.open(
                    `/utils/wordeditor?${editorParams.toString()}`,
                    "_blank",
                  );
                  const refreshOnSave = () => {
                    if (props.attachedLevelId && props.attachedLevelName) {
                      asyncAction.asyncOperationStart(GET_DOCUMENTS, {
                        attachedLevelId: props.attachedLevelId,
                        attachedLevelName: props.attachedLevelName,
                        showForCoderReviewInd: includeNonAuditLevelDocumentInd,
                        isManagerView: props.isManagerView,
                        uniqueId: dataSourceStoreId,
                      });
                    } else {
                      asyncAction.asyncOperationStart(GET_DOCUMENTS, {
                        monthRange: monthRange,
                        isManagerView: props.isManagerView,
                        uniqueId: dataSourceStoreId,
                      });
                    }
                  };
                  window.addEventListener("documentSaved", refreshOnSave, {
                    once: true,
                  });
                  if (!editorWindow) {
                    window.removeEventListener("documentSaved", refreshOnSave);
                    mdaeNotify({
                      message:
                        "Popup blocked. Please allow popups to create documents.",
                      messageType: NOTIFY_MESSAGE_TYPE.ERROR,
                    });
                  }
                }}
              />
            </div>
            {isEsmdDashboardButtonVisible && (
              <div>
                <MdaeButton
                  id={"btnSendToesMDDashboard"}
                  className={"upload-doc"}
                  role={"primary"}
                  text="esMD Dashboard"
                  icon="/images/ui-rewrite-icons/auditicons/upload-white.svg"
                  onClick={() => {
                    if (documentsGridSelectionMode === "multiple") {
                      const selectedRowsData = documentDataGridInstance.getSelectedRowsData();
                      if (selectedRowsData && selectedRowsData.length) {
                        //validations
                        if (
                          !(
                            isCurrentRequesterReviewContractorValid &&
                            isCurrentContentTypeInvalidForReviewContractor
                          )
                        ) {
                          mdaeNotify({
                            message: isCurrentRequesterReviewContractorValid
                              ? "You are unable to Create or Send a submission with an invalid Content Type selected. Please update the Content Type for the Review Contractor associated with your Requester"
                              : "You are unable to Create or Send a submission with an invalid Review Contractor selected. Please update the Review Contractor associated with your Requester.",
                            messageType: NOTIFY_MESSAGE_TYPE.ERROR,
                          });
                          return;
                        }

                        let totalSelectedFileSize = getSelectedDocumentFileSize();
                        if (
                          !isValidateFileSizeForEsmdOrSmartScan(
                            totalSelectedFileSize +
                            uploadedDraftDocumentTotalSize
                          )
                        ) {
                          mdaeNotify({
                            message:
                              "You have reached the " +
                              getReleventFileSizeUnitFromBytes(
                                ESMD_FILE_SIZE.FILE_SIZE
                              ) +
                              " per submission limit. Additional documents will need to be sent in a separate Submission.",
                            messageType: NOTIFY_MESSAGE_TYPE.ERROR,
                          });
                          return;
                        }
                        dispatch({ type: SHOW_LOADER });
                        let documenteIdsList = [];
                        let obj = { documentId: 0 };
                        selectedRowsData.map((item) => {
                          let newObj = { ...obj };
                          newObj.documentId = item.documentId;
                          documenteIdsList.push(newObj);
                        });
                        let data = {
                          esmdDocumentUploadList: documenteIdsList,
                          isSubmissionDraft: true,
                          eaCaseId: caseDetailData?.eaCaseId,
                        };
                        callOperation(CREATE_ESMD_DOCUMENT_DRAFT, data).then(
                          function (response) {
                            dispatch({ type: HIDE_LOADER });
                            if (response.isSaved) {
                              dispatch({
                                type: SET_CASE_DETAIL_DATA,
                                data: {
                                  eaCaseDetailsTabPanelSelectedIndex: 5,
                                },
                              });
                              dispatch({
                                type: SET_ESMD_SELECTED_TAB_INDEX,
                                data: {
                                  esmdSelectedTabIndex: 0,
                                  isTabChangedProgrammatically: true,
                                },
                              });
                              mdaeNotify({
                                message: getNotifyMessage(documenteIdsList),
                                messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
                              });
                            }
                          }
                        );
                        toggleDocumentGridCheckboxes();
                      } else {
                        toggleDocumentGridCheckboxes(
                          USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION
                        );
                      }
                    } else {
                      setCurrentUserActionMode(USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION)
                      toggleDocumentGridCheckboxes(
                        USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION
                      );
                    }
                  }}
                />
              </div>
            )}
          </div>
          <MdaeDataGrid
            {...documentListDataGridOptions}
            height={props.height ?? "100%"}
            dataSource={documentList}
            onEditorPreparing={onEditorPreparing}
            mdaeDataGridCustomButtons={renderToolbarButtonTemplate}
            onContentReady={(e) => {
              if (
                currentUserActionMode === USER_ACTION_MODE.MULTIPLE_DOWNLOAD
              ) {
                toggleTitleOfSelectAllCheckBox(e.component, true);
              } else {
                toggleTitleOfSelectAllCheckBox(e.component, false);
              }
              if (props.attachedLevelName?.toUpperCase() === "EAC") {
                const documentGridDataSource = e.component.getDataSource();
                documentGridDataSource
                  ?.store()
                  .load({ take: documentGridDataSource.totalCount() })
                  .then(function (result: any[]) {
                    let documentCount = result.filter(
                      (x) => x.attachedLevelName == "EAC"
                    ).length;
                    dispatch({
                      type: UPDATE_CASE_DETAIL_LIST_DATA,
                      data: {
                        eaCaseId: props.attachedLevelId,
                        documentCount:
                          documentCount == 0 ? null : documentCount,
                      },
                    });
                  });
              }
              if (!props.isManagerView) {
                var dataSource = e.component.getDataSource();
                if (dataSource) {
                  dataSource
                    .store()
                    .load({ take: dataSource.totalCount() })
                    .then(function (result: any[]) {
                      var unscannedFiles = result.filter(
                        (x) => x.attachedLevelName !== 'DL' && (x.maliciousFileInd === null || x.isDocumentConverted === false)
                      );
                      if (unscannedFiles.length > 0) {
                        if (!poolingIntervalId)
                          setUpPoolingForUnscannedFiles(false, dispatch);
                      } else {
                        setUpPoolingForUnscannedFiles(true, dispatch);
                      }
                    });
                }
              }
            }}
            onCellClick={(e) => {
              if (e.rowType === "header" && (e.column as any).command === "select") {
                dispatch({
                  type: TOGGLE_DOCUMENT_SELECT_ALL_FLAG,
                  isDocumentSelectAllCheckBoxClicked: true,
                });
              }
            }}
            onCellPrepared={(e) => {
              if (e.rowType == "data" && e.data.maliciousFileInd == null && e.data.attachedLevelName !== 'DL') {
                $(e.cellElement).css("font-style", "italic");
                setTimeout(() => {
                  $(e.cellElement)
                    .find(".mdae-datagrid-action-ellipsis-icon")
                    .removeClass("fas fa-ellipsis-h");
                  $(e.cellElement)
                    .find(".mdae-datagrid-action-ellipsis-icon")
                    .addClass("fas fa-hourglass-half");
                  $(e.cellElement).attr("title", "Virus scan in progress");
                });
              } else if (e.rowType == "data" && e.data.maliciousFileInd) {
                $(e.cellElement).addClass("malicious-document");
                setTimeout(function () {
                  $(e.cellElement)
                    .find(".mdae-datagrid-action-ellipsis-icon")
                    .addClass("malicious-document");
                  $(e.cellElement).attr(
                    "title",
                    "This file was found to be infected with malware and cannot be viewed or downloaded."
                  );
                  if (
                    currentUserActionMode === USER_ACTION_MODE.MULTIPLE_DOWNLOAD
                  ) {
                    $(e.cellElement)
                      .find(".dx-select-checkbox")
                      .attr("style", "display: none");
                    $(e.cellElement).attr("style", "pointer-events: none");
                  }
                });
              } else if (
                e.rowType == "data" &&
                (e.column as any).command === "select" &&
                currentUserActionMode === USER_ACTION_MODE.DELETE &&
                e.data.isDocInEsmdSubmission
              ) {
                var instance = CheckBox.getInstance(
                  e.cellElement.querySelector(".dx-select-checkbox")
                );
                instance.option("visible", false);
                e.cellElement.style.pointerEvents = "none";
              }
            }}
            onSelectionChanged={(e: SelectionChangedEvent) => {
              if(typeof props.setSelectedRowData === "function")
                if (
                  currentUserActionMode === USER_ACTION_MODE.VALIDATE_SINGLE_SELECTION
                ) {
                  const rows = e.selectedRowsData;
                  if (
                    Array.isArray(rows) &&
                    rows.length === 1
                  ) {
                    const row = first(rows);
                    if(row.fileType=== "xlsx"){
                    dispatch({
                      type: SET_DOCUMENT_DATA_TO_SAVE,
                      data: {
                        selectedDocumentId: row.documentId,
                      },
                    });
                    props.setSelectedRowData(rows);}
                  }
                }
                else{
                  props.setSelectedRowData(e.selectedRowKeys);
                }
              if (
                currentUserActionMode === USER_ACTION_MODE.MULTIPLE_DOWNLOAD
              ) {
                var maliciousSelectionRows = e.selectedRowsData?.filter(
                  (x) => x.maliciousFileInd
                );
                if (maliciousSelectionRows && maliciousSelectionRows.length) {
                  e.component.deselectRows(
                    maliciousSelectionRows.map((x) => x.documentId)
                  );
                }
                if (e.currentSelectedRowKeys.length === 1) {
                  if (isMaxDownloadLimitReached(e.selectedRowsData)) {
                    e.component.deselectRows(e.currentSelectedRowKeys);
                    showMaxDataDownloadMessage(false);
                  }
                } else if (e.currentSelectedRowKeys.length > 1) {
                  var selectedItems = e.selectedRowsData,
                    store = new ArrayStore({ data: selectedItems, key: "" });
                  store
                    .load({
                      sort: e.component.getDataSource().sort(),
                      filter: e.component.getDataSource().filter(),
                    })
                    .then(function (sortedList) {
                      const excludedDocumentList = getexcludedDocumentItemListDueToDownloadLimit(
                        sortedList
                      );
                      if (
                        selectedItems.length === excludedDocumentList.length
                      ) {
                        showMaxDataDownloadMessage(false);
                      }
                      if (excludedDocumentList.length) {
                        showMaxDataDownloadMessage(true);
                        e.component.deselectRows(excludedDocumentList);
                      }
                    });
                }
              }

              if (
                currentUserActionMode ===
                USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION ||
                currentUserActionMode ===
                USER_ACTION_MODE.SMART_SCAN_SINGLE_SELECTION
              ) {
                 e.component.refresh();
                const deselectRowKeys: number[] = [];
                e.selectedRowsData.forEach((item) => {
                  if (!isFileSelectableForESMDOrSmartScan(item))
                    deselectRowKeys.push(e.component.keyOf(item));
                });
                if (deselectRowKeys.length) {
                  e.component.deselectRows(deselectRowKeys);
                }

                if(currentUserActionMode ===
                  USER_ACTION_MODE.MULTIPLE_ESMD_SELECTION){
                    datagridSelectionRef.current.checkBoxUpdating = true;
                    const selectAllCheckBox = datagridSelectionRef.current.selectAllCheckBox;
                    selectAllCheckBox?.option("value", isSelectAll(e.component));
                    datagridSelectionRef.current.checkBoxUpdating = false;
                  }

              }

              if( currentUserActionMode ===
                USER_ACTION_MODE.SMART_SCAN_SINGLE_SELECTION){
                  if(e.selectedRowKeys.length > 1){
                    e.component.deselectRows(e.selectedRowKeys[0]);
                  }
              }
            }}
          ></MdaeDataGrid>
        </div>
      </div>
      {props.doNotLoadEditDocumentPopup || <EditDocumentPopup
        taskAttachmentLevel ={props.taskAttachmentLevel}
        parentAttachmentLevelId={props.parentAttachmentLevelId}
        parentAttachmentLevelName={props.parentAttachmentLevelName}
        showDocumentLibrary={props.showDocumentLibrary}
        uniqueId={dataSourceStoreId}
      ></EditDocumentPopup>}
      <ZipFileDonwloaConfirmPopup
        bulkDownloadDocumentsHandler={bulkDownloadDocumentsHandler}
        toggleDocumentGridCheckboxes={toggleDocumentGridCheckboxes}
        documentDataGridInstance={documentDataGridInstance}
      ></ZipFileDonwloaConfirmPopup>
      <StopDocumentPooling></StopDocumentPooling>
    </div>
  );
};
const MAX_FILE_DOWNLOAD_LIMIT = 1024 * 1024 * 1024;

const getexcludedDocumentItemListDueToDownloadLimit = (selectedItems) => {
  let totalFileSize = 0;
  let lastIndex = -1;
  const excludedDocumentItemList = [];
  for (let i = 0; i < selectedItems.length; i++) {
    if (selectedItems[i].isDocumentDownloaded) {
      excludedDocumentItemList.push(selectedItems[i].documentId);
    } else {
      totalFileSize += selectedItems[i].fileSize;
      if (totalFileSize > MAX_FILE_DOWNLOAD_LIMIT) {
        lastIndex = i;
        break;
      }
    }
  }
  if (lastIndex > -1) {
    for (let i = lastIndex; i < selectedItems.length; i++) {
      excludedDocumentItemList.push(selectedItems[i].documentId);
    }
  }

  return excludedDocumentItemList;
};

const isMaxDownloadLimitReached = (selectedItems) => {
  let totalFileSize = 0;
  for (let i = 0; i < selectedItems.length; i++) {
    if (!selectedItems[i].maliciousFileInd)
      totalFileSize += selectedItems[i].fileSize;
    if (totalFileSize > MAX_FILE_DOWNLOAD_LIMIT) {
      return true;
    }
  }
  return false;
};

const getDataGridVisibleRows = (documentDataGridInstance) => {
  return new Promise(function (resolve, reject) {
    const dataSource = documentDataGridInstance.getDataSource();
    if (!dataSource) {
      resolve([]);
      return;
    }
    dataSource
      .store()
      .load({
        sort: dataSource.sort(),
        filter: documentDataGridInstance.getCombinedFilter(true),
      })
      .then((gridDataSourceData) => {
        resolve(gridDataSourceData);
      });
  });
};
const getDocumentListDataGridOptions = (
  toggleActionPopover,
  dispatch,
  onDocumentsDataGridInitialized,
  hasAuditViewAccess,
  isIncludeNonAuditLevelDocumentCheckBoxVisible,
  isExternalAuditRelatedDocument,
  documentList,
  documentSelection,
  dataSourceStoreId,
  selectedRowsData,
  documentSelectionCellRender,
  attachedLevelName,
  isEhrInboundAPIEnabled
) => {
  const documentListDataGridOptions: IMdaeDataGridProps = {
    id: "grdDocumentList",
    allowColumnResizing: true,
    onInitialized: onDocumentsDataGridInitialized,
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    mdaeSearchPanel: { visible: true },
    clearFilterButtonId: "btn-sample-grid-clear-filter",
    export: { enabled: true, fileName: "DocumentList" },
    filterRow: { visible: true },
    headerFilter: { visible: true },
    pageSize: isIncludeNonAuditLevelDocumentCheckBoxVisible ? 10 : 20,
    scrolling: {
      columnRenderingMode: "virtual",
    },
    dataSource: documentList,
    mdaeColumns: [
      {
        visible: isEhrInboundAPIEnabled && attachedLevelName === "EAC" ? true : false,
        showInColumnChooser: false,
        fixed: true,
        width: 50,
        cellRender(e) {
          return (
            e.data.isDocumentConverted === false && (
              <div title="Document conversion in progress">
                <CircularProgressWithLabel
                  value={null}
                  width={25}
                  height={25}
                  fontSize={7}
                />
              </div>
            )
          );
        },
      },
      {
        fixed: true,
        allowSorting: false,
        allowFiltering: false,
        allowGrouping: false,
        allowResizing: false,
        allowReordering: false,
        allowHiding: false,
        allowExporting: false,
        dataField: "documentId",
        caption: "",
        alignment: "center",
        showInColumnChooser: false,
        width: 50,
        cellRender: documentSelectionCellRender,
      },
      {
        dataField: "documentName",
        caption: "File Name",
        allowFiltering: true,
        allowSorting: true,
        fixed: true,
        allowHiding: false,
        minWidth: 300,
      },
      {
        dataField: "fileType",
        caption: "File Type",
        allowFiltering: true,
        allowSorting: true,
        minWidth: 80,
      },
      {
        dataField: "fileSizeDisplayName",
        calculateSortValue: "fileSize",
        caption: "File Size",
        minWidth: 80,
        allowFiltering: false,
        allowSorting: true,
        alignment: "right",
        cellRender: (e) => e.data.fileSizeDisplayName || getReleventFileSizeUnitFromBytes(e.data.fileSize) || "",
      },
      {
        dataField: "documentCategoryName",
        caption: "Category",
        allowFiltering: true,
        allowSorting: true,
        minWidth: 200,
      },
      {
        dataField: "attachedLevelDisplayName",
        caption: "Level",
        allowFiltering: true,
        allowSorting: true,
        minWidth: 100,
        cellRender: (cellData) => {
          let attachedLevelName = cellData.displayValue;
          if (attachedLevelName?.toLowerCase() == "auditcase") {
            attachedLevelName = "Case";
          } else if (attachedLevelName?.toLowerCase() == "auditentity") {
            attachedLevelName = "Entity";
          }
          return attachedLevelName;
        },
      },
      {
        dataField: "attachedLevelTitle",
        caption: "Level Name",
        allowFiltering: true,
        allowSorting: true,
        minWidth: 250,
      },
      {
        dataField: "auditId",
        caption: "Audit ID",
        visible: false,
        allowFiltering: true,
        allowSorting: true,
        minWidth: 100,
        cellRender: (cellData) => {
          let auditId = cellData.displayValue;
          if (auditId === 0) {
            return "N/A";
          } else return auditId;
        },
      },
      {
        dataField: "createdBy",
        caption: "Uploaded By",
        allowFiltering: true,
        allowSorting: true,
        minWidth: 150,
      },
      {
        dataField: "createDate",
        caption: "Uploaded On",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,

        minWidth: 120,
      },
      {
        dataField: "updatedBy",
        caption: "Updated By",
        allowFiltering: true,
        allowSorting: true,
        minWidth: 150,
      },
      {
        dataField: "updateDate",
        caption: "Updated On",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,
        sortOrder: "desc",
        minWidth: 120,
      },
      {
        dataField: "auditTitle",
        cellRender: (cellData) => {
          if (hasAuditViewAccess && cellData.data) {
            const externalAuditLevels = ["EA", "EAC"];
            const auditURLString =
              externalAuditLevels.includes(cellData.data.attachedLevelName) ||
              (cellData.data.attachedLevelName == "TS" &&
                externalAuditLevels.includes(
                  cellData.data.parentAttachedLevelName,
                ))
                ? "/externalaudit/audit?auditId="
                : "/audit/index/?auditId=";
            return (
              <a href={auditURLString + cellData.data.auditId} target="_blank">
                {cellData.displayValue}
              </a>
            );
          } else return cellData.displayValue;
        },
        caption: "Audit",
        allowFiltering: true,
        allowSorting: true,
        visible: !isIncludeNonAuditLevelDocumentCheckBoxVisible,
        showInColumnChooser: !isIncludeNonAuditLevelDocumentCheckBoxVisible,
        minWidth: 250,
      },
      {
        dataField: "auditStatus",
        caption: "Audit Status",
        allowFiltering: true,
        allowSorting: true,
        visible: !isIncludeNonAuditLevelDocumentCheckBoxVisible,
        showInColumnChooser: !isIncludeNonAuditLevelDocumentCheckBoxVisible,
        minWidth: 150,
      },
      {
        dataField: "primaryAuditorName",
        caption: "Primary Auditor",
        allowFiltering: true,
        allowSorting: true,
        visible: !isIncludeNonAuditLevelDocumentCheckBoxVisible,
        showInColumnChooser: !isIncludeNonAuditLevelDocumentCheckBoxVisible,
        minWidth: 150,
      },
      {
        dataField: "showForCoderReviewInd",
        caption: "Coder View",
        allowFiltering: true,
        allowSorting: false,
        allowEditing: false,
        allowGrouping: false,
        dataType: "boolean",
        falseText: "No",
        trueText: "Yes",
        visible: !isIncludeNonAuditLevelDocumentCheckBoxVisible,
        showInColumnChooser: !isIncludeNonAuditLevelDocumentCheckBoxVisible,
        minWidth: 100,
        cellRender: (cellData) => {
          let isShowForCoderReviewInd = cellData.displayValue;
          if (!isShowForCoderReviewInd) {
            return "N/A";
          } else return <MdaeCheckBox id="" value={true} />;
        },
      },
      {
        visible: isExternalAuditRelatedDocument,
        dataField: "roundSubmittedSequenceNos",
        allowFiltering: true,
        allowSorting: true,
        showInColumnChooser: false,
        minWidth: 80,
        caption: "Round Submitted",
        cellRender: esmdRoundSubmittedCellRender,
      },
      {
        visible: isExternalAuditRelatedDocument,
        dataField: "source",
        minWidth: 80,
        caption: "Source",
      },
    ],
    selection: documentSelection,
  };
  if(selectedRowsData){
    documentListDataGridOptions.selectedRowKeys = selectedRowsData;
  }
  return documentListDataGridOptions;
};

export default DocumentManagement;
